import { LineItem } from "gpc-shared-types";
import ItemLine from "./ItemLine";

export type ProductListProps = {
  items: LineItem[];
  selectedItems?: any[];
  onSelectionChange: (id: string, selected: boolean) => void;
};

export const ProductList = ({
  items,
  selectedItems = [],
  onSelectionChange,
}: ProductListProps) => {
  const isSelected = (item: any) => {
    return !!selectedItems.find((selectedItem) => selectedItem.id === item.id);
  };

  return (
    <div className="gpc__item-list">
      {items
        .filter((item) => item.currentQuantity > 0)
        .map((item) => (
          <ItemLine
            {...item}
            key={item.id}
            selected={isSelected(item)}
            onSelectionChange={onSelectionChange}
          />
        ))}
    </div>
  );
};

export default ProductList;
